




























































































import { Component, Mixins, Watch, Emit } from "vue-property-decorator";
import { TextBoxItem } from "../../../../domain/document/items/TextBoxItem";
import { TextBoxInputMethodKinds } from "../../../../domain/document/inputMethodKinds/TextBoxInputMethodKinds";
import {
  IConfiguration,
} from "../../../../domain/configuration";
import { IHisInformationGroupSource } from "../../../../domain/his/groupInput/HisInformationGroupSource";
import { IObjectStyleReadable } from "../IObjectStyleReadable";
import { TextObjectStyleReader } from "../styleReaders";
import {
  StyledTextEditableObjectMixin,
  DataValidatableMixin,
  ImeControllableMixin,
  HisInformationSelectableMixin,
} from "./mixins";
import { FontSizeCalculator } from "../../../../domain/drawing";
import { ImelessTextarea } from "../../../system";
import { IDcoumentDataDroppableObject } from "./IDcoumentDataDroppableObject";
import { IDocumentDataDragParameter } from "../../../dragging";

@Component({
  components: {
    ImelessTextarea,
  },
})
export default class HisInfoTextBoxObject extends Mixins(
  StyledTextEditableObjectMixin,
  DataValidatableMixin,
  ImeControllableMixin,
  HisInformationSelectableMixin,
) implements IDcoumentDataDroppableObject {
  @Emit()
  updateInputElement(element: HTMLInputElement): void {}

  mounted(): void {
    this.updateInputElement(this.getInputableElement());
  }

  get editStyleReader(): IObjectStyleReadable {
    const configuration = this.$store.getters.configuration as IConfiguration;
    return new TextObjectStyleReader(configuration.style.document.editor.objects.textBox);
  }

  editingSource: TextBoxItem;

  get text(): string {
    this.updateTextPositionHeight();
    if (this.shouldDisplayHisItemName) {
      return this.editingSource.displayName;
    }
    return this.hisInfoValue;
  }

  set text(value: string) {
    this.writeProperty((s: TextBoxItem) => {
      const newValue = this.validateText(this.editingSource, value);
      if (this.isFreeInputable && this.isFreeInputOverwrittenByAll && this.isFocused && s.value !== newValue) {
        // 「全てフリー入力」の状態で手入力された場合はフリー入力に切り替える
        s.shouldInputFree = true;
      }
      s.value = newValue;
      if (s.shouldAutoAdjustHeight) {
        s.geometry.rectangle.size.height = FontSizeCalculator.calculateObjectHeight(s);
      }
    });
  }

  get measureText(): string {
    this.updateTextPositionHeight();
    return this.textPositionCompositing
      ? this.textPositionMeasureText
      : this.text;
  }

  get freeInputText(): string {
    return this.text;
  }

  set freeInputText(value: string) {
    // 定型文をドロップした際、TextFreeInputableMixin経由でアクセスされる場合があるためプロパティ追加している（textプロパティをfreeInputTextに置き換えても良さそう？）
    this.text = value;
  }

  onBlur(): void {
    if ((!this.editingSource.isEmpty || this.editingSource.textStyle.isAdjustedFontSize) && !this.editingSource.shouldAutoAdjustHeight) {
      this.autoAdjustFontSizeWithRetry();
    }
  }

  get hisInfoValue(): string {
    const value = this.editingSource.value;
    if (typeof value === "string") {
      return value;
    }
    return "";
  }

  get shouldInputFree(): boolean {
    return this.inputMethodKind === TextBoxInputMethodKinds.FreeInput;
  }

  /**
   * HIS項目名を表示するか。
   * 入力不可/データ選択入力 かつ 値が空のときHIS項目名を表示する。
   */
  get shouldDisplayHisItemName(): boolean {
    if (this.shouldInputFreeSelfOrAll) { return false; }

    const kinds = [
      TextBoxInputMethodKinds.None,
      TextBoxInputMethodKinds.HisInfoSelect,
    ];
    return (0 <= kinds.indexOf(this.inputMethodKind)) && this.isEmptyValue;
  }

  /** 入力方法 */
  get inputMethodKind(): TextBoxInputMethodKinds {
    return this.editingSource.inputMethodKind;
  }

  set inputMethodKind(type: TextBoxInputMethodKinds) {
    this.writeProperty((s: TextBoxItem) => {
      s.inputMethodKind = type;
    });
  }

  /** 空文字か */
  get isEmptyValue(): boolean {
    return this.hisInfoValue === "";
  }

  showInputDialog(): void {
    if (this.inputMethodKind === TextBoxInputMethodKinds.HisInfoSelect && !this.shouldInputFreeSelfOrAll && !this.isEditDisabledByRuleSet) {
      this.selectHisInformation(r => this.onHisItemSelected(r));
    }
  }
  
  async onHisItemSelected(result: IHisInformationGroupSource): Promise<boolean> {
    if (!result) {
      this.inputMethodKind = TextBoxInputMethodKinds.FreeInput;
    }
    return true;  // 処理継続可否は任せる.
  }

  @Watch("shouldInputFreeSelfOrAll")
  onShouldInputFreeChanged(newValue: boolean, oldValue: boolean): void {
    if (!this.isFreeInputable) { return; }
    if (!this.isFocused) { return; }
    if (!newValue) { return; }
    // IEでは、いったんマウスクリックさせるかフォーカス外さないとreadonlyの切り替えが反映されない模様
    this.$nextTick(() => {
      const element = this.getInputableElement();
      if (element == null) { return; }
      element.blur();
      element.focus();
      element.select();
      this.updateInputElement(element);
    });
  }

  get isMultiLine(): boolean {
    return this.editingSource.isMultiLine;
  }

  getInputableElement(): HTMLInputElement {
    return this.shouldUseImelessTextarea
      ? !!this.$refs.imelessTextarea
        ? (this.$refs.imelessTextarea as ImelessTextarea).getEditor() as unknown as HTMLInputElement
        : null
      : this.isMultiLine
        ? this.$refs.textarea as HTMLInputElement
        : this.$refs.input as HTMLInputElement;
  }
  
  @Watch("inputMethodKind")
  updatedInputMethodKind(newValue: TextBoxInputMethodKinds, oldValue: TextBoxInputMethodKinds): void {
    if (newValue !== TextBoxInputMethodKinds.HisInfoSelect && oldValue !== TextBoxInputMethodKinds.FreeInput) {
      this.showInputDialog();
    }
    this.$nextTick(() => {
      this.updateInputElement(this.getInputableElement());
    });
  }

  get labelStayle(): any {
    if (this.shouldDisplayHisItemName) { return null; }
    return {
      whiteSpace: "pre",
    };
  }

  get titleWithLengthDescription(): string {
    return this.appendLengthDescription(this.title, this.editingSource);
  }

  get title(): string {
    if (this.toolTip) {
      return this.toolTip;
    }
    return this.editingSource.displayName;
  }

  setDroppedDocumentData(text: string, param: IDocumentDataDragParameter): void {
    if (this.shouldInputFreeSelfOrAll) {
      console.warn("過去データ貼り付けの処理で意図していないパスを通っています。実装を確認してください。");
      return;
    }
    if (!this.isFreeInputable || !text) { return; }
    this.writeProperty((s: TextBoxItem) => {
      s.shouldInputFree = true;
      const joinedText = s.value + text;
      const arrangedText = this.isMultiLine
        ? joinedText
        : joinedText.replace(/\r/g, "").replace(/\n/g, "");
      s.value = this.validateText(this.editingSource, arrangedText);
      if (s.shouldAutoAdjustHeight) {
        s.geometry.rectangle.size.height = FontSizeCalculator.calculateObjectHeight(s);
      }
    });
    this.$nextTick(() => {
      const element = this.getInputableElement();
      if (!!element) {
        element.focus();
      }
    });
  }
}
